import { AsyncPipe, NgForOf, NgIf, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NiceBreadcrumbComponent } from "@recursyve/ngx-panko";
import { NiceLayoutModule } from "@recursyve/nice-ui-kit.v2";
import { NavbarModule } from "../dashboard/components/navbar/navbar.module";
import { UnauthorizedQuery } from "./store/unauthorized.query";
import { UnauthorizedService } from "./store/unauthorized.service";
import { UnauthorizedStore } from "./store/unauthorized.store";

import { UnauthorizedComponent } from "./unauthorized.component";

@NgModule({
    imports: [
        NiceLayoutModule,
        AsyncPipe,
        MatButtonModule,
        MatIconModule,
        NavbarModule,
        NiceBreadcrumbComponent,
        RouterOutlet,
        NgOptimizedImage,
        TranslateModule,
        NgIf,
        NgForOf
    ],
    declarations: [UnauthorizedComponent],
    providers: [UnauthorizedQuery, UnauthorizedService, UnauthorizedStore],
    exports: [UnauthorizedComponent]
})
export class UnauthorizedModule {}
